import { ComponentModule } from './components/component.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicRouteStrategy, provideIonicAngular, IonApp, IonContent, IonGrid, IonRow, IonCol, IonRouterOutlet } from '@ionic/angular/standalone';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { VersionInterceptor } from './interceptors/version.interceptor';
import { ShardHealthInterceptor } from './interceptors/shard-health.interceptor';
import { environment } from 'src/environments/environment';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ModalImagePageModule } from './pages/modal-image/modal-image.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteEventsService } from './services/route-events.service';
import { ModalGpsTrackingPageModule } from './pages/modal-gps-tracking/modal-gps-tracking.module';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import 'chartjs-plugin-zoom';
import { TimezoneService } from './components/main-menu/services/timezone.service';

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    ModalImagePageModule,
    ModalGpsTrackingPageModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    ComponentModule,
    ServiceWorkerModule.register('ngsw-worker.js',
      { enabled: environment.production }),
    IonApp,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonRouterOutlet],
  providers: [
    TimezoneService,
    RouteEventsService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
    // Registered last so its GET retries run closest to the network and do not re-trigger
    // the ErrorInterceptor. See ShardHealthInterceptor for the ordering rationale.
    { provide: HTTP_INTERCEPTORS, useClass: ShardHealthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true,
    }),
  ],
})
export class AppModule { }
